import React from "react";

export default function RedownloadModel({ handleCancelDownload, handleConfirmDownload, downloading }) {

  if (downloading) {
    return (
      <div className="modelspace pplication-fe">
        <div className="flex flex-col items-center justify-center gap-3 py-6">
          <div className="animate-spin h-8 w-8 border-4 border-t-blue-600 border-gray-300 rounded-full"></div>
          <p className="model-desc-details">
            Applying your settings — this can take a moment...
          </p>
        </div>
      </div>
    );
  }

  return (

    <div className="modelspace pplication-fe">
      <p className="model-desc-details  notice-icon">
        Downloading and applying a user template will overwrite your current user settings.
        Do you want to continue?
      </p>

      <div className="frm-btn popup-2-btn">
        <button class="submit-btn btn-bg inpt-btn btn-discard" onClick={handleCancelDownload}>
          Cancel
        </button>
        <button class="submit-btn btn-bg inpt-btn" onClick={handleConfirmDownload}>
          Continue
        </button>
      </div>
    </div>
  );
}
